define('modules/error/error_view',[
  'backbone',
  'jquery',
  '_',

  'text!./error_template.html'
], function (Backbone, $, _, template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);
      if (!this.message) {
        this.message = 'Något är fel, försök igen.';
      }
    },

    hasSidebar: false,
    subViews: [],

    tagName: 'div',
    className: 'error-modal-content',

    template: _.template(template),

    render: function () {
      this.$el.html(this.template({message: this.message}));
      return this;
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }
  });
  return View;
});
